module.exports = __webpack_public_path__ + "static/media/kh.b0788c76.svg";